import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LogService } from '@prekog/common-ui';

import { ProductStatisticTotals } from '../../shared/models/product-statistic-totals.model';
import { ProductStatistics } from '../../statistics/productstatistic/productstatistics.model';
import { CalculateStatisticTotalsUseCase } from '../../shared/use-cases/calculate-statistic-totals.usecase';

@Injectable({
    providedIn: 'root'
})
export class CalculateProductStatisticTotalsUseCase extends CalculateStatisticTotalsUseCase<ProductStatistics, ProductStatisticTotals> {
    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override extractRowTotals(row: ProductStatistics): ProductStatisticTotals {
        return {
            printed: row.printedQuantity ?? 0,
            sold: (row.soldQuantity ?? 0) + (row.soldOnWebQuantity ?? 0) + (row.soldFromDelegationQuantity ?? 0),
            office: row.officeQuantity ?? 0,
            warehouse: row.warehouseQuantity ?? 0,
            webSales: row.soldOnWebQuantity ?? 0,
            stayedInDelegation: row.stayedInDelegationQuantity ?? 0
        };
    }
}
